export default __webpack_public_path__ + "static/media/hr-testimonial.06879472.png";